import { Box } from '@chakra-ui/react';
import { Paper } from '@material-ui/core';
import { useSelectedView } from 'reducers/viewsSlice';
import { ErrorInData, NoDataAvailable } from 'screens/analytics/commonComponents';
import GroupedByCompetenciesTable from 'screens/analytics/continuousFeedback/GroupedByCompetenciesTable/GroupedByCompetenciesTable';
import GroupedByEmployeesTable from 'screens/analytics/continuousFeedback/GroupedByEmployeesTable/GroupedByEmployeesTable';
import GroupedByFunctionTable from 'screens/analytics/continuousFeedback/GroupedByFunctionTable/GroupedByFunctionTable';
import { GroupedByIndividualTable } from 'screens/analytics/continuousFeedback/GroupedByIndividualTable/GroupedByIndividualTable';
import CFbarChartSection from 'screens/analytics/continuousFeedback/cfBarChart/CFbarChartSection';
import { useLevelUpAnalytics } from 'screens/analytics/continuousFeedback/context';

import NoFeedbackInsights from 'assets/assetsV1/illustrations/newIllustrations/noFeedbackInsights.svg';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { CFSplitButton } from './components/CFSplitButton';
import { useSelectCompetenciesSelectedGroupBy } from './slice/CompetenciesIntentSlice';

const CompetenciesInsightsIntent = () => {
  const {
    state: {
      currentState: { noData, errorData },
    },
  } = useLevelUpAnalytics();

  const sideNavSelectedCohort = useSelectedView();

  const selectedGroupByValue = useSelectCompetenciesSelectedGroupBy(sideNavSelectedCohort?.id);

  return (
    <div>
      <Box>
        <CFbarChartSection />
        <PaperWithShadow p={3}>
          <CFSplitButton />
          {errorData && (
            <Paper elevation={0} overFlow="auto" marginBottom="2rem" padding="0" topGutter={2}>
              <ErrorInData />
            </Paper>
          )}
          {noData && (
            <Paper elevation={0} overFlow="auto" marginBottom="2rem" padding="0" topGutter={2}>
              <NoDataAvailable src={NoFeedbackInsights} />
            </Paper>
          )}
          {!noData && !errorData && (
            // <TableContainer>
            <>
              {selectedGroupByValue?.keyName === 'competency' && <GroupedByCompetenciesTable />}
              {selectedGroupByValue?.keyName === 'orgTree' && <GroupedByEmployeesTable />}
              {selectedGroupByValue?.keyName === 'employeeId' && <GroupedByIndividualTable />}
              {selectedGroupByValue?.keyName === 'function' && <GroupedByFunctionTable />}
            </>
            // </TableContainer>
          )}
        </PaperWithShadow>
      </Box>
    </div>
  );
};

export { CompetenciesInsightsIntent };
